<lib-preloader [loading]="loading" [text]="config.downloadText"></lib-preloader>
<lib-preloader [loading]="uploading" [text]="config.uploadingText"></lib-preloader>
<ng-container *ngIf="!uploading && !isEng">
    <div class="start-test-wrapper" *ngIf="!isStartConfirmed && !loading && !isActive">
        <div class="container">
            <div class="row">
                <div class="col-md-6">
                    <h2>
                        Відкалібровано.
                    </h2>
                    <h3>
                        Ви чудово розпочали! Технічна частина завершена. Далі продивіться ці пари зображень
                    </h3>
                    <p>
                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M10.5889 19.1696C15.3279 19.1696 19.1696 15.3279 19.1696 10.5889C19.1696 5.84995 15.3279 2.00824 10.5889 2.00824C5.84995 2.00824 2.00824 5.84995 2.00824 10.5889C2.00824 15.3279 5.84995 19.1696 10.5889 19.1696ZM10.5889 21.1779C16.437 21.1779 21.1779 16.437 21.1779 10.5889C21.1779 4.74082 16.437 0 10.5889 0C4.74082 0 0 4.74082 0 10.5889C0 16.437 4.74082 21.1779 10.5889 21.1779Z"
                                  fill="#805FFF"/>
                            <path d="M10.2227 5.32227V11.8223H14.7227" stroke="#805FFF" stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"/>
                        </svg>
                        тривалість {{timeOfTesting ? timeOfTesting + ' хв' : 'розраховується'}}
                    </p>
                    <button type="button" class="btn btn-primary  mb-3 " (click)="onStartConfirmed()">
                        Розпочати перегляд
                    </button>
                </div>
                <div class="col-md-6 d-flex flex-column justify-content-center align-items-center">
                    <img src="assets/icons/eye.gif" alt="eye">
                    <br>
                    <p>Проходьте тестування в цьому ж положенні голови і тіла.<br>Намагайтесь дивитись на
                        хрестик, коли
                        він
                        з’являється.</p>
                </div>
            </div>
        </div>
    </div>
    <div class="start-warning-wrapper" *ngIf="isStartConfirmed && !isActive">
        <div class="container">
            <div class="row">
                <div class="col-md-6">
                    <h3>
                        Увага! Зображення, що можуть викликати тривожність! Розпочинайте тест на власний розсуд.
                    </h3>
                    <button type="button" class="btn btn-primary  mb-3 " (click)="onStart()">
                        Все одно почати
                    </button>
                </div>
                <div class="col-md-6 d-flex flex-column justify-content-center align-items-center">
                    <img src="assets/icons/esc.gif" alt="esc">
                    <br>
                    <p>Ви можете зупинити тест в будь-який момент<br>натиснувши Esc на клавіатурі</p>
                </div>
            </div>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="!uploading">
    <div id="body" class="test-wrapper" [ngClass]="{'isActive': isActive}">
        <!--    *ngFor="let slide of steps; let i=index"-->
        <div #wrapper>
            <div class="slide-wrapper container-fluid mb-3 "
                 *ngIf="currentStepIndex > -1"
                 [ngClass]="{'lose-face': !detected}">
                <div class="slide empty-slide text-center"
                     [ngClass]="{'active':steps[currentStepIndex]?.type === 'empty'}">
                    <img class="plusIcon" *ngIf="steps[currentStepIndex]?.type === 'empty'"
                         (load)="onImgLoad($event, 'empty',0)"
                         [src]="'assets/icons/empty-focus.png'">
                    <app-circle-progress [progress]="currentStepIndex *100 / steps.length">
                    </app-circle-progress>

                </div>

                <div *ngIf="!isReading" class="slide imageSet"
                     [ngClass]="{'active':imageSetLoaded}">
                    <div class="wrapper">
                        <div #lImgWrapper class="lImgWrapper">
                            <img class="img"
                                 (load)="onImgLoad($event, 'imageSet', 1)"
                                 [ngClass]="steps[currentStepIndex]?.data?.l_type" #lImg
                                 [src]="steps[currentStepIndex]?.data?.l_src.src" alt="">
                            <!--              <img class="portrait"-->
                            <!--                   src="https://api-fcqs5w5o5a-ew.a.run.app/api/storage/content/12479672">-->
                        </div>
                        <div #rImgWrapper class="rImgWrapper">
                            <img
                                    class="img"
                                    (load)="onImgLoad($event, 'imageSet', 2)"
                                    [ngClass]="steps[currentStepIndex]?.data?.r_type"
                                    #rImg [src]="steps[currentStepIndex]?.data?.r_src.src" alt="">
                        </div>

                    </div>
                </div>
                <div *ngIf="isReading" class="slide imageSet reading"
                     [ngClass]="{'active':imageSetLoaded}">

                    <div class="wrapper">
                        <div class="text" id="text">
                            <lib-reading-instructions [hideResultWarning]="!isReading"
                                                      [text]="config.readingInfo"></lib-reading-instructions>

                            <lib-dast-renderer
                                    *ngIf="steps[currentStepIndex]?.article?.document"
                                    [dastNode]="steps[currentStepIndex].article.document"></lib-dast-renderer>
                        </div>
                        <div class="answers">
                            <div
                                    class="articleImgWrapper"
                                    [attr.style]="'height: ' + getImageHeight(steps[currentStepIndex].images) + '%'"
                                    [ngClass]="{'active': img.id === selectedImg?.id}"
                                    *ngFor="let img of steps[currentStepIndex].images; let i = index">
                                <img class="img"
                                     [id]="'x'+i"
                                     (load)="onImgLoad($event, 'article', i)"
                                     (click)="onImgSelected(img)"
                                     [src]="steps[currentStepIndex].images[i].src">
                            </div>
                            <div class="action-wrapper">
                                <button
                                        [disabled]="!selectedImg"
                                        (click)="onActionClick(selectedImg)"
                                        class="action-btn hover_action">
                                    Далі
                                    <svg width="8" height="14" viewBox="0 0 8 14" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 13.1328L7 7.13281L1 1.13281" stroke="#fff" stroke-width="1.5"
                                              stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="uploading">

</ng-container>
<div class="dot" style="position: absolute; top: 50px; left: 150px">

</div>
